import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slices/userSlice";
import registrationSlice from "./slices/registrationSlice";
import profileSlice from "./slices/profileSlice";
import dashboardSlice from "./slices/dashboardSlice";
import employeeSlice from "./slices/employeeSlice";
import storeSlice from "./slices/storeSlice";
import customerSlice from "./slices/customerSlice";
import supplierSlice from "./slices/supplierSlice";
import companySlice from "./slices/companySlice";
import studentSlice from "./slices/studentSlice";
// Product & Category module (merged from ProductAndCategoryMFE)
import productSlice from "./slices/productSlice";
import productItemSlice from "./slices/productItemSlice";
import categorySlice from "./slices/categorySlice";
// Order management module (merged from OrderManagementMFE)
import purchaseOrderSlice from "./slices/purchaseOrderSlice";
import salesOrderSlice from "./slices/salesOrderSlice";
import invoiceSlice from "./slices/invoiceSlice";
import paymentSlice from "./slices/paymentSlice";
import receiptSlice from "./slices/receiptSlice";
// Membership module (merged from MembershipMFE)
import planSlice from "./slices/planSlice";
import subscriptionSlice from "./slices/subscriptionSlice";

export const store = configureStore({
  reducer: {
    user: userSlice,
    registration: registrationSlice,
    profile: profileSlice,
    dashboard: dashboardSlice,
    employees: employeeSlice,
    store: storeSlice,
    customers: customerSlice,
    suppliers: supplierSlice,
    company: companySlice,
    students: studentSlice,
    products: productSlice,
    productItems: productItemSlice,
    categories: categorySlice,
    purchaseOrders: purchaseOrderSlice,
    salesOrders: salesOrderSlice,
    invoices: invoiceSlice,
    payments: paymentSlice,
    receipts: receiptSlice,
    plans: planSlice,
    subscriptions: subscriptionSlice
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
